import React from "react";
import { useSelector } from "react-redux";
import { DataGrid, GridToolbar } from "@material-ui/data-grid";

export const GrillaAportes = () => {
  const { items, cargada } = useSelector((state) => state.aportesAfiliado);

  const rows = items.map((i,n) => {
    return {
      id: n,
      periodo: i.dperiodo1,
      sitCuil: i.sitCuil,
      descripSitRev: i.descrip_SitRev,
      accion: i.accion,
      aporta: i.aporta,
      Apadios: i.apadios,
      remimpo: i.remimpo,
      remcont: i.remcont,
      origrect: i.origrect,
      aporte: i.aporte,
      contribucion: i.contribucion,
      CantFamCargo: i.cantFamCargo,
      //adicional
      AdicFamCargo: i.adicFamCargo,
      imposad: i.imposad,
      totalAporteOs: i.totalAporte_OS,
      transferidoAporte: i.transferido_Aporte,
      transferidoContribucion: i.transferido_Contribucion,
      totalTransferido: i.totalTransferido,
      Transferido_Aporte: i.transferido_Aporte,
      Transferido_Contribucion: i.transferido_Contribucion,
      denominacion: i.denominacion,
      cuit: i.cuit,
      nomArch: i.nomArch,
      cuil: i.cuil,
    };
  });

  const columns = [
    { field: "periodo", headerName: "Período", width: 100 },
    { field: "sitCuil", headerName: "Sit CUIL", width: 70 },
    { field: "descripSitRev", headerName: "Desc Sit", width: 330 },
    { field: "accion", headerName: "Acción", width: 150 },
    { field: "totalAporteOs", headerName: "Total Aporte OS", width: 100 },
    { field: "totalTransferido", headerName: "Transf.Total", width: 100 },
    { field: "Transferido_Aporte", headerName: "Transf.Aporte", width: 100 },
    { field: "Transferido_Contribucion",headerName: "Transf.Contribución",width: 100},
    { field: "aporte", headerName: "Aporte", width: 100 },
    { field: "contribucion", headerName: "Contribución", width: 100 },
    { field: "remimpo", headerName: "Rem Imponible", width: 100 },
    { field: "remcont", headerName: "Rem Cont", width: 100},
    { field: "Apadios", headerName: "Adic.", width: 70 },
    { field: "imposad", headerName: "ImpoSad", width: 70 },
    { field: "AdicFamCargo", headerName: "Adic.Fam a Cargo", width: 70 },
    { field: "CantFamCargo", headerName: "Cant.Fam a Cargo", width: 70 },
    { field: "denominacion", headerName: "Denominación", width: 250 },
    { field: "cuit", headerName: "CUIT", width: 125 },
    { field: "origrect", headerName: "Origrect", width: 100 },
    { field: "nomArch", headerName: "NomArchivo", width: 350 },
    { field: "cuil", headerName: "CUIL", hide: true, width: 125 },
    { field: "aporta", headerName: "Aporta", hide: true, width: 100 },
  ];

  return (
    <div style={{ height: 600, width: "100%" }}>
      {cargada && (
        <DataGrid
          disableColumnMenu = {true}
          rowHeight={25}
          rows={rows}
          columns={columns}
          showToolbar
          pageSize={20}
          rowsPerPageOptions={[20, 40, 60]}
          localeText={{
            noRowsLabel: "No hay información",
            toolbarDensity: "Tamaño",
            toolbarDensityLabel: "Tamaño",
            toolbarDensityCompact: "Chico",
            toolbarDensityStandard: "Mediano",
            toolbarDensityComfortable: "Grande",
            toolbarColumns: "Columnas",
            toolbarColumnsLabel: "Seleccion de Columnas",
            toolbarFilters: "Filtros",
            toolbarFiltersLabel: "Mostrar Filtros",
            toolbarFiltersTooltipHide: "Ocultar Filtros",
            toolbarFiltersTooltipShow: "Mostrar Filtros",
            toolbarFiltersTooltipActive: (count) => `${count} Filtros Activos`,
            // Columns panel text
            columnsPanelTextFieldLabel: "Buscar columna",
            columnsPanelTextFieldPlaceholder: "Columnas",
            columnsPanelDragIconLabel: "Reordenar Columnas",
            columnsPanelShowAllButton: "Mostrar Todas",
            columnsPanelHideAllButton: "Ocultar Todas",
            // Filter panel text
            filterPanelAddFilter: "Agregar Filtros",
            filterPanelDeleteIconLabel: "Eliminar",
            filterPanelOperators: "Operador",
            filterPanelOperatorAnd: "Y",
            filterPanelOperatorOr: "O",
            filterPanelColumns: "Columnas",
            // Filter operators text
            filterOperatorContains: "Contiene",
            filterOperatorEquals: "Igual",
            filterOperatorStartsWith: "Empieza con",
            filterOperatorEndsWith: "temrina con",
            filterOperatorIs: "es",
            filterOperatorNot: "no es",
            filterOperatorOnOrAfter: "despues",
            filterOperatorBefore: "antes",
            filterOperatorOnOrBefore: "antes",
            // Column menu text
            columnMenuLabel: "Menu",
            columnMenuShowColumns: "Mostrar",
            columnMenuFilter: "Filtros",
            columnMenuHideColumn: "Ocultar",
            columnMenuUnsort: "Deshacer",
            columnMenuSortAsc: "Ordenar Asc",
            columnMenuSortDesc: "Ordenar Desc",
            // Column header text
            columnHeaderFiltersTooltipActive: (count) =>
              `${count} filtros activos`,
            columnHeaderFiltersLabel: "Filtros",
            columnHeaderSortIconLabel: "Ordenar",
            // Rows selected footer text
            footerRowSelected: (count) =>
              count !== 1
                ? `${count.toLocaleString()} filas seleccionadas`
                : `${count.toLocaleString()} fila seleccionada`,
            // Total rows footer text
            footerTotalRows: "Total Registros:",
            // Pagination footer text
            footerPaginationRowsPerPage: "Registros por página:",
          }}
          components={{
            Toolbar: GridToolbar,
          }}
        />
      )}
    </div>
  );
};